import service from '@/utils/https'

export const fetchHandbooks = (params) =>
  service.get('/api/app/v1/handbooks', {
    params,
  })

export const createHandbook = (payload) => 
  service.post('/api/app/v1/handbooks', payload)

export const deleteHandbook = (handbookId) => 
  service.delete(`/api/app/v1/handbooks/${handbookId}`)

export const updateHandbook = (handbookId, payload) =>
  service.put(`/api/app/v1/handbooks/${handbookId}`, payload)

export const getHandbookDownloadUrl = (handbookId, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.team_id) queryParams.append('team_id', params.team_id);
  const queryString = queryParams.toString();
  return service.get(`/api/app/v1/handbooks/${handbookId}/download${queryString ? `?${queryString}` : ''}`);
}

export default {
  fetchHandbooks,
  createHandbook,
  deleteHandbook,
  updateHandbook,
  getHandbookDownloadUrl,
}
